<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <vuexy-logo />
        <!-- <h2 class="brand-text text-primary ml-1">
          BC Wallets
        </h2> -->
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
                  style="width: 400px!important;"
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            class="mb-1 font-weight-bold"
            title-tag="h2"
          >
            Welcome to BC Wallets!
          </b-card-title>

          <!-- <b-card-text class="mb-2">
            Please sign-in to your account and start the adventure
          </b-card-text> -->

          <!-- <b-alert
            variant="primary"
            show
          >
            <div class="alert-body font-small-2">
              <p>
                <small class="mr-50"><span class="font-weight-bold">Admin:</span> admin@demo.com | admin</small>
              </p>
              <p>
                <small class="mr-50"><span class="font-weight-bold">Client:</span> client@demo.com | client</small>
              </p>
            </div>
            <feather-icon
              v-b-tooltip.hover.left="'This is just for ACL demo purpose'"
              icon="HelpCircleIcon"
              size="18"
              class="position-absolute"
              style="top: 10; right: 10;"
            />
          </b-alert> -->

          <!-- form -->
          <validation-observer
            ref="loginForm"
            #default="{invalid}">

            <b-form class="auth-login-form mt-2"
                    @submit.prevent="signin">

              <!-- email -->
              <b-form-group
                :label="$t('labels.email')"
                label-for="login-email">

                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  vid="email"
                  rules="required|email">

                  <b-form-input
                    id="login-email"
                    @input="findClients()"
                    v-model="email"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    placeholder="john@email.com"/>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group
                :label="$t('labels.password')"
                label-for="login-password">
                <!-- <div class="d-flex justify-content-between">
                  <label for="login-password">Password</label>
                  <b-link :to="{name:'auth-forgot-password'}">
                    <small>Forgot Password?</small>
                  </b-link>
                </div> -->
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      :placeholder="$t('labels.password')"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- client to connect -->
              <b-form-group>
                  <validation-provider
                          #default="{ errors }"
                          name="Email"
                          class=""
                          rules="required">

                      <div class="d-flex flex-row align-items-center p-0 m-0">

                          <vue-typeahead-bootstrap v-model="query"
                                                   style="width: 86%"
                                                   :ieCloseFix="false"
                                                   :placeholder="$t('labels.client')"
                                                   :data="clientsQueryResponse"
                                                   :serializer="item => item.name"
                                                   :minMatchingChars="1"
                          />

                          <div class="ml-1">
                              <b-spinner small type="grow"
                                         v-if="findingClients"/>
                              <feather-icon v-else
                                            icon="LayersIcon"
                                            size="13"/>
                          </div>

                      </div>

                  </validation-provider>

              </b-form-group>

              <!-- checkbox -->
              <!-- <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Remember Me
                </b-form-checkbox>
              </b-form-group> -->

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid"
              >
                <span v-if="!requestLoginLoading || loginAuthError">{{$t('buttons.signIn')}}</span>
                <b-spinner v-else label="Spinning" small type="grow"></b-spinner>
              </b-button>
            </b-form>
          </validation-observer>

          <!-- <b-card-text class="text-center mt-2">
            <span>New on our platform? </span>
            <b-link :to="{name:'auth-register'}">
              <span>&nbsp;Create an account</span>
            </b-link>
          </b-card-text> -->

          <!-- divider -->
          <!-- <div class="divider my-2">
            <div class="divider-text">
              or
            </div>
          </div> -->

          <!-- social buttons -->
          <!-- <div class="auth-footer-btn d-flex justify-content-center">
            <b-button
              variant="facebook"
              href="javascript:void(0)"
            >
              <feather-icon icon="FacebookIcon" />
            </b-button>
            <b-button
              variant="twitter"
              href="javascript:void(0)"
            >
              <feather-icon icon="TwitterIcon" />
            </b-button>
            <b-button
              variant="google"
              href="javascript:void(0)"
            >
              <feather-icon icon="MailIcon" />
            </b-button>
            <b-button
              variant="github"
              href="javascript:void(0)"
            >
              <feather-icon icon="GithubIcon" />
            </b-button>
          </div> -->
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, BAlert, BSpinner, VBTooltip,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import { mapActions, mapState, mapMutations } from 'vuex'
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import {defineAbilitiesFor} from  '../../../../src/libs/acl/ability'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    VuexyLogo,
    VueTypeaheadBootstrap,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      email: '',
      sideImg: require('@/assets/images/pages/loginImg.svg'),
      query: '',
      clientsQueryResponse : [],
      findingClients : false,
      requestLoginLoading : false,
      coinUrl: require('@/assets/images/pages/shared/coin.png'),

      // validation rules
      required,
    }
  },
  computed: {
    ...mapState('user',['authError']),

    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },

    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        // this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        this.sideImg = require('@/assets/images/pages/loginImg.svg')
        return this.sideImg
      }
      return this.sideImg
    },

    loginAuthError(){
      return this.authError
    }

  },
  methods: {
    ...mapActions('user', ['login']),
    ...mapActions('client', ['getClientsByEmail']),
    ...mapMutations('user',['SET_AUTH_ERROR']),

    signin() {
      this.$refs.loginForm.validate()
      .then(async success => {
        if(success){
          this.requestLoginLoading = true
          this.SET_AUTH_ERROR(false)
          await this.login({ email: this.email, password: this.password , clientId : this.getClientFromArray(this.query) })
            .then(response => {
              const userData = response.user
              userData.role = userData.role.toLowerCase()
              userData.client = response.client
              useJwt.setToken(response.token)
              useJwt.setRefreshToken(response.token)
              let rules = defineAbilitiesFor(userData.role); // user is grabbed from vuex inside this function
              this.$ability.update(rules.rules);
              userData.ability = rules.rules
              localStorage.setItem('userData', JSON.stringify(userData))

              // this.$ability.update([{ action : 'manage', subject: 'all' }])

              // ? This is just for demo purpose as well.
              // ? Because we are showing eCommerce app's cart items count in navbar
              // this.$store.commit('app-ecommerce/UPDATE_CART_ITEMS_COUNT', userData.extras.eCommerceCartItemsCount)

              // ? This is just for demo purpose. Don't think CASL is role based in this case, we used role in if condition just for ease
              this.$router.replace(getHomeRouteForLoggedInUser(userData.role))
                .then(() => {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: `${this.$t('messages.welcome')} ${userData.fullName || userData.userName}`,
                      icon: 'CoffeeIcon',
                      variant: 'success',
                      text: `${this.$t('messages.loginText1')} ${userData.role}. ${this.$t('messages.loginText2')}` ,
                    },
                  })
                })
            })
            .catch(error => {
              this.$swal({
                title: 'Error!',
                text: this.$t('labels.verifyCredentials'),
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
            })
              this.requestLoginLoading = false
          })
        }
      }).catch(error => {
        this.$refs.loginForm.setErrors(error.response.data.error)
      })
    },

    async findClients(){
      if (this.email){
        this.findingClients = true
        await this.getClientsByEmail(this.email)
                .then(response=>{this.clientsQueryResponse = response})
                .finally(()=>{this.findingClients = false})
      }
    },

    //in backend the clientName is unique
    getClientFromArray(clientName){
      let client = null
      let foundClient = this.clientsQueryResponse.find(client => client.name.toLowerCase() === clientName.toLowerCase())
      if (foundClient)
        client = foundClient.id
      return client
    }

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
